import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCameraFlip = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "inherit",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M25 6.62V4a1 1 0 1 1 2 0v5.333a1 1 0 0 1-1 1h-5.334a1 1 0 0 1 0-2h3.22A10.965 10.965 0 0 0 16 5c-6.076 0-11 4.925-11 11a1 1 0 1 1-2 0c0-7.18 5.82-13 13-13 3.493 0 6.666 1.38 9 3.62ZM8.113 23.667h3.22a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1V28a1 1 0 1 0 2 0v-2.62A12.959 12.959 0 0 0 16 29c7.18 0 13-5.82 13-13a1 1 0 1 0-2 0c0 6.075-4.925 11-11 11a10.965 10.965 0 0 1-7.888-3.333Z",
		clipRule: "evenodd"
	})
});
export default SvgCameraFlip;
